import { Avatar, Box, Typography } from '@mui/material'
import moment from 'moment'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import LabelRanking from 'component/LabelRanking'
import PatientEnglishNameTooltip from 'component/Treatments/PatientEnglishNameTooltip'

/** UTILS */
import { getCrm, getMember, toBuddhistYear } from 'utils/app.utils'

/** CONSTANTS */
import { icons, imgs } from 'constants/images'
import { colors } from 'constants/theme'

/** STYLE */
import { styled } from '@mui/material/styles'
import _ from 'lodash'

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  width: 49,
  height: 49,
  [theme.breakpoints.up('lg')]: {
    width: 56,
    height: 56
  }
}))

type BtnProfileProps = {
  profile: string
  branchCnNumber: string
  firstName: string
  lastName: string
  firstnameEn?: string
  lastnameEn?: string
  displayName?: string
  rankId: number
  lastVisit?: string
  vnNumber?: string
  disabled?: boolean
  hideArrow?: boolean
}

export default function BtnProfile(props: BtnProfileProps) {
  const { t } = useTranslation()
  const memberAll = getMember()

  const checkDisplayName = () => {
    return props.displayName ? (`(${props.displayName})`) : ``
  }

  const rankData = _.find(memberAll, { rankId: props.rankId });
  return (
    <>
      <ProfileAvatar alt="profile" src={props.profile} sx={{ border: `3px solid ${props.disabled ? 'transparent' : getCrm() ? rankData?.color : colors.black12}`, backgroundColor: colors.white }}>
        <img src={imgs.defaultAvatar} className="w-100 h-100" alt="defaultAvatar" />
      </ProfileAvatar>
      <Box className="ml-3 d-flex flex-column" sx={{ flex: 1, overflow: 'hidden', minWidth: 0, justifyContent: 'flex-start' }}>
        <Typography noWrap sx={{ fontSize: '16px !important', fontWeight: '600 !important', color: colors.themeMainColor, lineHeight: 1.4 }}>
          {props.branchCnNumber ? `${props.branchCnNumber} | ` : ''}{props.firstName && props.lastName && (`${props.firstName} ${props.lastName} ${checkDisplayName()}`) || (t('REGISTER.TITLE.FULL_NAME'))}
        </Typography>
        <PatientEnglishNameTooltip firstnameEn={props.firstnameEn} lastnameEn={props.lastnameEn} />
        <Box className="d-flex flex-wrap" sx={{ alignItems: 'center', gap: '6px', mt: '3px' }}>
          {getCrm() && <LabelRanking disabled={props.disabled} rankId={props.rankId} compact />}
          {props.lastVisit && (
            <Typography sx={{ fontSize: '12px !important', color: colors.themeMainColor, lineHeight: 1.3 }}>
              {getCrm() ? '· ' : ''}{t('TREATMENTS.TITLE.LAST_VISIT')} {props.lastVisit ? toBuddhistYear(moment(props.lastVisit), 'DD/MM/YYYY') : ''}
            </Typography>
          )}
        </Box>
        {props.vnNumber && (
          <Typography sx={{ fontSize: '12px !important', color: colors.disabledGray, lineHeight: 1.4 }}>
            {t('VN')} {props.vnNumber}
          </Typography>
        )}
      </Box>
      {!props.hideArrow && <img src={icons.arrowExpand} width={14} height={14} className={'ml-3'} alt="ArrowExpand" />}
    </>
  )
}
